import { purify } from 'components/Purifier'
import TextField from '@material-ui/core/TextField'

export default purify(TextField)
